module.exports = __webpack_public_path__ + "img/step3.f42644b1.png";